import { Canvas, useFrame } from "@react-three/fiber";
import { useEffect, useMemo, useRef, useState } from "react";
import { useTexture } from "@react-three/drei";
import * as THREE from "three";
import axios from "axios";
import Orb from "./Orb";
import "./App.css";
import Header from "./header";

function App() {

  return (
    <div className="App">
      {/* <Header /> */}

      <section className="hero">
        <div className="hero__orb">
          <Orb />
         <div className="hero__caption">
          Figure 1: a model of the Hopf fibration <br/> on the Poincaré disk. Built in GLSL <br/>  and embedded with React Three Fiber.
        </div>
        </div>

        <div className="hero__intro">
          <h1>Hi, I’m Joaquim</h1>
          <p>
            I'm a junior (almost) at Harvard College studying Mathematics and Classics and dabbling in linguistics. Currently I am reseraching the representation stability of Hurwitz spaces and modules under the mentorship of Aaron Landesman.
          </p>
          <p>
            In Math, my interests currently include algebraic geometry and representation theory. 
          </p>
          {/* <p>
            In Classics, I am interested in ...
          </p> */}
        </div>
      </section>
    </div>
    
  );
}

export default App;